import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef, useState } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closed } from "../../components/drawer/drawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  couponcodeImageUpload,
  createCouponCode,
  getAllActiveCouponCode,
  getAllCouponCodes,
  getCouponCodeById,
  updateCouponCode,
} from "./services/couponcode.services";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { DISC_TYPE, STATUSARRAY } from "../../_contstants/common";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { clearCouponCodeDetails, clearCouponCodeID } from "./couponcodeSlice";
import IconComponent from "../../components/common/IconComponent";
import { ISector } from "../sector/sectorModel";
import { getAllActiveSectors } from "../sector/services/sector.services";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import FormImageUpload from "../../components/formFields/FormImageUpload";

const CrateCouponCode: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const CouponCodeDetail = useAppSelector(
    (state) => state.couponcode.CouponCodeDetail,
  );
  const CouponCodeID = useAppSelector((state) => state.drawer.data);
  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);
  const formLoading = useAppSelector((state) => state.couponcode.formLoading);
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getAllActiveSectors());

    return () => {
      dispatch(clearCouponCodeDetails());
      dispatch(clearCouponCodeID());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (CouponCodeID) {
      dispatch(getCouponCodeById(CouponCodeID));
    }
  }, [CouponCodeID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [CouponCodeDetail]);

  const handleSubmit = async (values: any) => {
    const ImageData = new FormData();
    const CouponImage =
      values?.CouponImage && typeof values?.CouponImage !== "string"
        ? values?.CouponImage[0]?.getRawFile()
        : "";

    try {
      if (!CouponCodeID) {
        const payload = {
          CouponCode: values?.CouponCode,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : "",
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : "",
          DestinationID: values?.DestinationID ? +values?.DestinationID : null,
          UsageCount: values?.UsageCount ? +values?.UsageCount : null,
          AmountType: values?.AmountType ? values?.AmountType : "",
          Percentage: values?.Percentage ? +values?.Percentage : null,
          Amount: values?.Amount ? +values?.Amount : null,
          MaxAmount: values?.MaxAmount ? values?.MaxAmount : null,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createCouponCode(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (values?.CouponImage && typeof values?.CouponImage !== "string") {
            ImageData.append("ID", response?.payload?.Data?.ID);
            ImageData.append("CouponImage", CouponImage);
            await dispatch(couponcodeImageUpload(ImageData));
          }
          dispatch(closed());
          dispatch(clearCouponCodeDetails());
          if (isIndirect) {
            dispatch(getAllActiveCouponCode());
          } else {
            dispatch(getAllCouponCodes());
          }
        }
      } else {
        const payload = {
          ID: CouponCodeID,
          CouponCode: values?.CouponCode,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : "",
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : "",
          DestinationID: values?.DestinationID ? +values?.DestinationID : null,
          UsageCount: values?.UsageCount ? +values?.UsageCount : null,
          AmountType: values?.AmountType ? values?.AmountType : "",
          Percentage: values?.Percentage ? +values?.Percentage : null,
          Amount: values?.Amount ? +values?.Amount : null,
          MaxAmount: values?.MaxAmount ? values?.MaxAmount : null,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateCouponCode(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (values?.CouponImage && typeof values?.CouponImage !== "string") {
            ImageData.append("ID", CouponCodeID);
            ImageData.append("CouponImage", CouponImage);
            await dispatch(couponcodeImageUpload(ImageData));
          }

          dispatch(closed());
          dispatch(clearCouponCodeDetails());
          dispatch(getAllCouponCodes());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {formLoading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={CouponCodeDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                marginRight: 10,
              }}
              gap={{ rows: 10, cols: 10 }}
              cols={[{ width: "50%" }, { width: "50%" }]}
            >
              <GridLayoutItem className="master-drawer-header" colSpan={2}>
                <Typography.h4 className="m-0">
                  {CouponCodeID ? "Update Coupon Code" : "Add Coupon Code"}
                </Typography.h4>
                <Button
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                >
                  <IconComponent icon={RxCross1} />
                </Button>
              </GridLayoutItem>
              {/* {!CouponCodeID && (
              <GridLayoutItem
                colSpan={2}
                className="flight-search-radio-griditem"
              >
                <Field
                  id={"Type"}
                  name={"Type"}
                  component={FormRadioGroup}
                  options={PROMO_TYPE}
                />
              </GridLayoutItem>
            )} */}

              <GridLayoutItem colSpan={2}>
                <Field
                  name="CouponCode"
                  label="Coupon Code"
                  component={FormTextField}
                  placeholder="Coupon Code"
                  astrike={true}
                  validator={requiredValidator}
                />
              </GridLayoutItem>
              <GridLayoutItem colSpan={1}>
                <Field
                  id={"FromDate"}
                  name={"FromDate"}
                  component={FormDatePicker}
                  label={"Validity From"}
                  validator={requiredValidator}
                  minDate={moment().toDate()}
                  onChange={(e) => {
                    if (
                      moment(e.value).isAfter(
                        moment(formRenderProps?.valueGetter("ToDate")),
                      )
                    ) {
                      formRenderProps.onChange("ToDate", { value: "" });
                    }
                  }}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem colSpan={1}>
                <Field
                  id={"ToDate"}
                  name={"ToDate"}
                  component={FormDatePicker}
                  label={"Validity To"}
                  minDate={
                    formRenderProps.valueGetter(`FromDate`)
                      ? moment(formRenderProps.valueGetter(`FromDate`)).toDate()
                      : moment().toDate()
                  }
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  wrapperClassName="w-100"
                  id={"DestinationID"}
                  name={"DestinationID"}
                  label={"Destination"}
                  placeholder="Destination"
                  component={FormSelectionField}
                  // astrike={true}
                  // validator={requiredValidator}
                  options={SectorList?.map((sector: ISector) => {
                    return {
                      value: sector?.ID,
                      label: sector?.SectorName,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem colSpan={1}>
                <Field
                  wrapperClassName="right-aligned-field"
                  name="UsageCount"
                  label="Usage Count"
                  placeholder="0"
                  format="n0"
                  component={FormNumericTextField}
                  astrike={true}
                  validator={requiredValidator}
                />
              </GridLayoutItem>
              <GridLayoutItem colSpan={1}>
                <Field
                  name={"AmountType"}
                  label={"Amount Type"}
                  component={FormSelectionField}
                  placeholder="Amount Type"
                  astrike={true}
                  validator={requiredValidator}
                  options={DISC_TYPE.map((type: any) => {
                    return {
                      value: type.value,
                      label: type.label,
                    };
                  })}
                  onChange={(e: any) => {
                    if (e?.value === "RS") {
                      ["MaxAmount", "Percentage"]?.map((field: any) => {
                        formRenderProps.onChange(field, {
                          value: "",
                        });
                      });
                    }
                  }}
                />
              </GridLayoutItem>
              {formRenderProps.valueGetter("AmountType") === "PER" && (
                <GridLayoutItem colSpan={1}>
                  <Field
                    wrapperClassName="right-aligned-field"
                    name="Percentage"
                    label="Percentage"
                    type="number"
                    placeholder="0"
                    max={100}
                    component={FormNumericTextField}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>
              )}
              <GridLayoutItem colSpan={1}>
                <Field
                  wrapperClassName="right-aligned-field"
                  name="Amount"
                  label="Amount"
                  type="number"
                  placeholder="0"
                  component={FormTextField}
                  astrike={
                    formRenderProps.valueGetter("AmountType") === "RS"
                      ? true
                      : false
                  }
                  validator={
                    formRenderProps.valueGetter("AmountType") === "RS"
                      ? requiredValidator
                      : skipValidator
                  }
                />
              </GridLayoutItem>
              {formRenderProps.valueGetter("AmountType") === "PER" && (
                <GridLayoutItem colSpan={1}>
                  <Field
                    wrapperClassName="right-aligned-field"
                    name="MaxAmount"
                    label="Max Amount"
                    type="number"
                    placeholder="0"
                    component={FormTextField}
                    // astrike={true}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
              )}
              <GridLayoutItem colSpan={2}>
                <Field
                  justifyContent="start"
                  name={`CouponImage`}
                  label="Main Image"
                  type="file"
                  accept="image/*"
                  alternateName="Main Image"
                  component={FormImageUpload}
                />
              </GridLayoutItem>
              <GridLayoutItem colSpan={1}>
                <Field
                  name="IsActive"
                  label="Status"
                  component={FormSelectionField}
                  validator={requiredValidator}
                  options={STATUSARRAY.map((type: any) => {
                    return {
                      value: type.value,
                      label: type.label,
                    };
                  })}
                  placeholder="Status"
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem
                colSpan={2}
                style={{
                  textAlign: "end",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={CouponCodeID ? "Update" : "Save"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || formLoading}
                  loading={formLoading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CrateCouponCode;
